<script> 
import apigeneric from "@/helpers/apigeneric";
export default { 
  mixins: [ apigeneric],
  data() {
    return {
      SlidersData:{} 
    };
  },
  components: { 
  }, 
  methods: { 
    Get(){
      
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1", 
    };
    this.ActionsFilterGet({ Service: "sliders", 
    Page: Page,
     Filter: "&Websiteid="+window.$cookies.get("ecampuswebsite")}).then(
        (res) => {
          this.SlidersData = res.Data; 
        }
      );
    },
     
  },
};
</script>

<template> 
<div>
       <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="4000"
              controls
              indicators
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333;" 
            >
              <!-- Text slides with image -->
              <b-carousel-slide :img-src="$config.FILES_URL + 'web/' + Data.Imageurl" v-for="Data in SlidersData" :key="Data.Id">
                <a :href="Data.Link" class="img-link" :target="Data.Target">   
                <h5 class="text-white">{{Data.Title}}</h5>
                </a>       
              </b-carousel-slide>

      </b-carousel>  
</div>
</template>
